import React from 'react';

import NodeGraph from './NodeGraph';

function DecorativeBoxesNodeGraph() {
  return (
    <NodeGraph
      groupId="red-boxes"
      initialState={{
        name: '',
      }}
      rows={[
        [
          {
            label: 'App',
            ownsState: 'name',
          },
        ],
        [
          {
            label: 'Boxes',
            parentId: 'app',
            props: ['boxes'],
            dependsOnState: ['name'],
            isPure: true,
          },
        ],
      ]}
    />
  );
}

export default DecorativeBoxesNodeGraph;
